import { render } from "./ViewDba.vue?vue&type=template&id=bb69efd2"
import script from "./ViewDba.vue?vue&type=script&lang=js"
export * from "./ViewDba.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__